export var fromMoviesDTO = function (movies) {
    if (movies) {
        return movies.map(function (movie) {
            return fromMovieDTO(movie);
        });
    }
    return [];
};
export var fromMovieDTO = function (movie) {
    if (movie.poster && movie.poster.includes("https://")) {
        movie.poster = "" + movie.poster;
    }
    else {
        movie.poster = ("" + process.env.REACT_APP_BASE_API + movie.poster).replace("..", "");
    }
    if (movie.banner && movie.banner.includes("https://")) {
        movie.banner = "" + movie.banner;
    }
    else {
        movie.banner = ("" + process.env.REACT_APP_BASE_API + movie.banner).replace("..", "");
    }
    if (movie.movieType === "series" &&
        movie.episodes &&
        movie.episodes.length > 0) {
        movie.episodes = movie.episodes.map(function (episode) {
            if (episode.thumbnail) {
                if (episode.thumbnail.includes("https://")) {
                    episode.thumbnail = "" + episode.thumbnail;
                }
                else {
                    episode.thumbnail =
                        ("" + process.env.REACT_APP_BASE_API + episode.thumbnail).replace("..", "");
                }
            }
            return episode;
        });
    }
    return movie;
};
export var fromContinueWatchingDTO = function (items) {
    return items.map(function (item) {
        if (item && item.movie && item.movie.poster.includes("https://")) {
            item.movie.poster = "" + item.movie.poster;
        }
        else if (item && item.movie && item.movie.poster) {
            item.movie.poster =
                ("" + process.env.REACT_APP_BASE_API + item.movie.poster).replace("..", "");
        }
        return item;
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/services/DTOs.ts
// module id = 60
// module chunks = 1